<template>
  <BaseNoticeItem
    data-test="paye-settings-alert"
    :button-text="$t('Edit PAYE settings')"
    :button-url="buttonUrl"
  >
    <template #head>
      <strong>{{ $t('Provide required PAYE details') }}</strong>
    </template>
    <template #body>
      <p>For the contract you can only be paid through a PAYE scheme.</p>

      <p>
        Your client has setup your contract for PAYE meaning your income will be subjected to
        employment tax and national insurance, even if you have a business set up. You will be taxed
        as an employee, with Worksome handling all the taxes. Please add more information before
        accepting this contract.
      </p>
    </template>
  </BaseNoticeItem>
</template>

<script setup>
import { computed } from 'vue'
import BaseNoticeItem from '@/components/BaseNoticeItem.vue'
import { useRedirectUri } from '@/composables/redirectUri'
import { useTranslation } from '@/composables/translation'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import namedRoutes from '@/utils/laravelNamedRoutes.json'

const props = defineProps({
  complianceData: {
    type: Object,
    required: true,
  },
  hire: {
    type: Object,
    required: true,
  },
  isComplete: {
    type: Boolean,
    required: true,
  },
})

const { $t } = useTranslation()

const { redirectUri } = useRedirectUri()

const buttonUrl = computed(() => {
  const path = laravelNamedRoute(namedRoutes.compliance.edit, {
    compliance: 'UkPayrollCompliance',
    redirect_uri: redirectUri,
  })
  return `${path}#uk-tax-information`
})
</script>
